import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';


import * as fromTicketsModuleModels from '../../../tickets/models';

@Component({
  selector: 'customer-ticket-list',
  styleUrls: ['customer-ticket-list.component.scss'],
  template: `

    <div class="card">
      <div class="card__heading">
        <span>Tickets für diesen Kunden</span>
      </div>

      <div class="card__content">
        <div class="ticket-list__outer">
          <div class="ticket-list__wrapper wrap">
            <div class="ticket-list grid">

              <div class="column-14">

                <div *ngIf="!items?.length; else table" style="padding: 24px;">
                  Keine Datensätze vorhanden
                </div>

                <ng-template #table>

                  <table *ngIf="items?.length" class="table" mat-table [dataSource]="items">

                    <!-- Ticket Number Column -->
                    <ng-container matColumnDef="ticketNumber">
                      <th mat-header-cell *matHeaderCellDef>Nr.</th>
                      <td mat-cell *matCellDef="let element">{{ element.ticketNumber }}</td>
                    </ng-container>

                    <!-- State Column -->
                    <ng-container matColumnDef="state">
                      <th mat-header-cell *matHeaderCellDef>Status</th>
                      <td mat-cell *matCellDef="let element">{{ element.order.stateRange }}</td>
                    </ng-container>

                    <!-- createdAt Column -->
                    <ng-container matColumnDef="createdAt">
                      <th mat-header-cell *matHeaderCellDef>Erstellt</th>
                      <td mat-cell *matCellDef="let element">{{ element.createdAt | date: 'dd.MM.Y - HH:mm' }} Uhr</td>
                    </ng-container>

                    <!-- updatedAt Column -->
                    <ng-container matColumnDef="updatedAt">
                      <th mat-header-cell *matHeaderCellDef>Letzte Aktivität</th>
                      <td mat-cell *matCellDef="let element">{{ element.updatedAt | date: 'dd.MM.Y - HH:mm' }} Uhr</td>
                    </ng-container>

                    <!-- Actions Column -->
                    <ng-container matColumnDef="actions">
                      <th mat-header-cell *matHeaderCellDef></th>
                      <td mat-cell *matCellDef="let element">

                        <button mat-icon-button (click)="handleRequestViewTicket(element['@id'])">
                          <mat-icon>remove_red_eye</mat-icon>
                        </button>
                      </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                  </table>
                </ng-template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `
})
export class CustomerTicketListComponent implements OnInit {

  @Input() items: Array<fromTicketsModuleModels.Ticket>;

  @Output()
  requestFetchTickets: EventEmitter<void> = new EventEmitter<void>();

  @Output()
  requestViewTicket: EventEmitter<string> = new EventEmitter<string>();

  displayedColumns = ['ticketNumber', 'state', 'createdAt', 'updatedAt', 'actions'];

  constructor() {
  }

  ngOnInit(): void {
    this.requestFetchTickets.emit();
  }

  handleRequestViewTicket(ticketIri: string): void {
    this.requestViewTicket.emit(ticketIri);
  }
}
